import React from 'react';
import CheckBoxOutlined from '@material-ui/icons/CheckBoxOutlined';

export default function CheckBoxOutlinedIcon() {

    return (
        <CheckBoxOutlined />
    );
}
